export default {
    'jpg': 'image/jpeg',
    'png': 'image/png',
    'gif': 'image/gif',
    'svg': 'image/svg+xml',
    'psd': 'image/photoshop'
};



//////////////////
// WEBPACK FOOTER
// ./~/vue-image-crop-upload/utils/mimes.js
// module id = 363
// module chunks = 1